// The operator of CelPal, named in every legal document on the site.
export const COMPANY = {
  name: 'Kodeus Mateusz Gawliński',
  shortName: 'Kodeus',
  streetAddress: 'ul. Powstańców Warszawskich 12/4',
  zipCode: '80-152',
  city: 'Gdańsk',
  country: 'Polska',
  nipNumber: '5783091813',
  email: 'kontakt@celpal.net',
  dataProtectionEmail: 'kontakt@celpal.net'
}

export const COMPANY_ADDRESS = `${COMPANY.streetAddress}, ${COMPANY.zipCode} ${COMPANY.city}`
